/**
 * Double-confirm for destructive actions — same pattern as Schedules delete:
 * first click arms the button; second click runs the action. Leaving the
 * control (or any other action) should call reset().
 */

/**
 * @param {HTMLButtonElement} btn
 * @param {{ idle: string, armed: string, onConfirm: () => void|Promise<void> }} opts
 */
export function armDestructive(btn, opts) {
  if (!btn || btn.disabled) return;
  if (btn.classList.contains('is-armed')) {
    opts.onConfirm();
    return;
  }
  btn.classList.add('is-armed');
  btn.textContent = opts.armed;
  btn.setAttribute('aria-pressed', 'true');
}

/** @param {HTMLButtonElement|null|undefined} btn @param {string} idle */
export function resetDestructive(btn, idle) {
  if (!btn) return;
  btn.classList.remove('is-armed');
  btn.textContent = idle;
  btn.removeAttribute('aria-pressed');
}
